import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: number;
  title: string;
  excerpt: string;
  category: string;
  author: string;
  authorAvatar: string;
  date: string;
  readTime: string;
  likes: number;
  comments: number;
  image: string;
  tags: string[];
}

export default function ArticleCard({
  id,
  title,
  excerpt,
  category,
  author,
  authorAvatar,
  date,
  readTime,
  likes,
  comments,
  image,
  tags,
}: ArticleCardProps) {
  return (
    <article className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200/60 transition-all duration-300 group cursor-pointer h-full flex flex-col">
      <Link to={`/article/${id}`} className="block no-underline">
        <div className="relative overflow-hidden w-full h-48">
          <img
            src={image}
            alt={title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <span className="absolute top-3 left-3 px-2.5 py-1 bg-background-50/90 backdrop-blur-sm rounded-md text-xs font-medium text-primary-600">
            {category}
          </span>
        </div>
      </Link>
      <div className="p-4 flex flex-col flex-1">
        <Link to={`/article/${id}`} className="no-underline">
          <h3 className="text-base font-semibold text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors mb-2">
            {title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-4 flex-1">
          {excerpt}
        </p>
        <div className="flex items-center gap-2 mb-3 flex-wrap">
          {tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded text-xs"
            >
              {tag}
            </span>
          ))}
        </div>
        <div className="flex items-center justify-between pt-3 border-t border-background-100">
          <div className="flex items-center gap-2">
            <img
              src={authorAvatar}
              alt={author}
              className="w-6 h-6 rounded-full object-cover"
            />
            <span className="text-xs text-foreground-600">{author}</span>
          </div>
          <div className="flex items-center gap-3 text-xs text-foreground-400">
            <span className="flex items-center gap-1">
              <i className="ri-heart-line"></i>
              {likes >= 1000 ? `${(likes / 1000).toFixed(1)}k` : likes}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-chat-1-line"></i>
              {comments}
            </span>
            <span>{readTime}</span>
          </div>
        </div>
      </div>
    </article>
  );
}